import axios from 'axios';
import Reducers from '../reducers';
import { Config, Validate } from '../../other';
import Cookies from 'js-cookie';
import amplitude from 'amplitude-js';

const adminAuthSet = () => {
  return (dispatch, getState) => {
    // guardo en redux
    dispatch({
      type: Reducers.AUTH_SET,
      data: JSON.parse(localStorage.getItem('auth')),
    });
  };
};

const adminAuthSetManual = () => {
  return (dispatch, getState) => {
    // guardo en redux
    dispatch({
      type: Reducers.AUTH_SET,
      data: {
        t_nombre: '',
        d_nombre: '',
      },
    });
  };
};

const crearTienda = (data, callback) => {
  return (dispatch, getState) => {
    axios
      .post(Config.BACKEND_ENDPOINT + '/tienda', data)
      .then((resp) => {
        // guardo en redux
        const data = resp.data.data;

        const auth_data = {
          d_nombre: data.dominio.d_nombre,
          t_nombre: data.tienda.t_nombre,
        };

        localStorage.setItem('first-login', 1);

        if (Config.USE_HEADER) {
          localStorage.setItem('token', data.token);
          axios.defaults.headers.common.Authorization = 'Bearer ' + data.token;
        }

        dispatch({ type: Reducers.AUTH_SET, data: auth_data });

        return callback(false, null);
      })
      .catch((err) => {
        return callback(true, Validate.procesar_error_axios(err.response));
      });
  };
};

const adminLogin = (usuario, callback) => {
  return (dispatch, getState) => {
    axios
      .post(Config.BACKEND_ENDPOINT + '/tienda/login', usuario)
      .then((resp) => {
        const data = resp.data.data;

        const auth_data = {
          d_nombre: data.dominio.d_nombre,
          t_nombre: data.tienda.t_nombre,
        };

        if (Config.USE_HEADER) {
          localStorage.setItem('token', data.token);
          axios.defaults.headers.common.Authorization = 'Bearer ' + data.token;
        }

        axios
          .get(Config.BACKEND_ENDPOINT + '/beta')
          .then((resp_beta) => {
            const beta_data = resp_beta.data.data;
            dispatch({ type: Reducers.BETA_GUARDAR, data: beta_data });

            dispatch({ type: Reducers.AUTH_SET, data: auth_data });

            return callback(false, null);
          })
          .catch((err) => {
            if (err.response && err.response.status === 401) {
              dispatch(adminLogout());
            }
            return callback(true, Validate.procesar_error_axios(err.response));
          });
      })
      .catch((err) => {
        return callback(true, Validate.procesar_error_axios(err.response));
      });
  };
};

const adminEnviarCodigo2FA = (usuario, callback) => {
  return (dispatch, getState) => {
    axios
      .post(Config.BACKEND_ENDPOINT + '/tienda/login/codigo', usuario)
      .then((resp) => {
        const data = resp.data.data;

        if (data.tienda) {
          const auth_data = {
            d_nombre: data.dominio.d_nombre,
            t_nombre: data.tienda.t_nombre,
          };

          if (Config.USE_HEADER) {
            localStorage.setItem('token', data.token);
            axios.defaults.headers.common.Authorization =
              'Bearer ' + data.token;
          }

          axios
            .get(Config.BACKEND_ENDPOINT + '/beta')
            .then((resp_beta) => {
              const beta_data = resp_beta.data.data;
              dispatch({ type: Reducers.BETA_GUARDAR, data: beta_data });

              dispatch({ type: Reducers.AUTH_SET, data: auth_data });

              return callback(false, { login: true });
            })
            .catch((err) => {
              if (err.response && err.response.status === 401) {
                dispatch(adminLogout());
              }
              return callback(
                true,
                Validate.procesar_error_axios(err.response)
              );
            });
        } else {
          return callback(false, { login: false });
        }
      })
      .catch((err) => {
        return callback(true, Validate.procesar_error_axios(err.response));
      });
  };
};

const adminRecuperarClave = (usuario, callback) => {
  return (dispatch, getState) => {
    axios
      .put(Config.BACKEND_ENDPOINT + '/tienda/recuperar-clave', usuario)
      .then((resp) => {
        return callback(false, resp.data);
      })
      .catch((err) => {
        return callback(true, Validate.procesar_error_axios(err.response));
      });
  };
};

const adminRecuperarClaveEmail = (usuario, callback) => {
  return (dispatch, getState) => {
    axios
      .put(
        Config.BACKEND_ENDPOINT +
          '/tienda/recuperar-clave/' +
          usuario.t_codigo_clave,
        usuario
      )
      .then((resp) => {
        return callback(false, resp.data);
      })
      .catch((err) => {
        return callback(true, Validate.procesar_error_axios(err.response));
      });
  };
};

const adminPromo = (usuario, callback) => {
  return (dispatch, getState) => {
    axios
      .put(
        Config.BACKEND_ENDPOINT +
          '/tienda/promo/' +
          usuario.t_email_hash +
          '/' +
          usuario.code,
        usuario
      )
      .then((resp) => {
        return callback(false, resp.data);
      })
      .catch((err) => {
        return callback(true, Validate.procesar_error_axios(err.response));
      });
  };
};

const adminLogout = () => {
  return (dispatch, getState) => {
    if (Config.USE_HEADER) {
      if (localStorage.getItem('token')) {
        localStorage.removeItem('token');
      }
    } else {
      axios.get(Config.BACKEND_ENDPOINT + '/tienda/logout');
      if (Cookies.get('is_auth')) {
        Cookies.remove('is_auth');
      }
    }
    if (localStorage.getItem('auth')) {
      localStorage.removeItem('auth');
    }
    dispatch({ type: Reducers.AUTH_UNSET });
    amplitude.getInstance().setUserId(0);
  };
};

const authBrazeUser = (callback) => {
  return (dispatch, _getState) => {
    axios
      .get(Config.BACKEND_ENDPOINT + '/braze')
      .then((resp) => {
        // guardo en redux
        const brazeToken = resp.data.data;
        dispatch({ type: Reducers.AUTH_BRAZE_USER, data: brazeToken });
        return callback(false, resp.data);
      })
      .catch((err) => {
        if (err.response && err.response.status === 401) {
          dispatch(adminLogout());
        }
        return callback(true, Validate.procesar_error_axios(err.response));
      });
  };
};

export {
  authBrazeUser,
  crearTienda,
  adminAuthSet,
  adminAuthSetManual,
  adminLogin,
  adminEnviarCodigo2FA,
  adminRecuperarClave,
  adminRecuperarClaveEmail,
  adminPromo,
  adminLogout,
};
